import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, IconButton, Stack, Tooltip, alpha, styled } from '@mui/material';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { SidebarContext } from 'src/contexts/SidebarContext';
import UserContext from 'src/context/UserContext';
import { Role } from 'src/Role';
import { brand } from 'src/theme/brand';
import ShopBrandMark from 'src/components/ShopBrandMark';
import { useCustomerShopBranding } from 'src/hooks/useCustomerShopBranding';
import HeaderButtons from './Buttons';
import HeaderUserbox from './Userbox';
import QuickSearch from './QuickSearch';
import Notifications, { headerIconButtonSx } from './Notifications';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 3)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(brand.canvas, 0.86)};
        backdrop-filter: blur(12px);
        -webkit-backdrop-filter: blur(12px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        transition: left .2s ease;
        @media (max-width: ${theme.breakpoints.values.sm}px) {
            padding: ${theme.spacing(0, 1.5)};
        }
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: var(--sidebar-w);
            width: auto;
        }
`
);

function Header() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const { isCustomer, shopName, shopLogoUrl, shopInitial } = useCustomerShopBranding();
  const [user] = useContext(UserContext);
  const navigate = useNavigate();

  return (
    <HeaderWrapper display="flex" alignItems="center" gap={1.5}>
      <Stack direction="row" alignItems="center" spacing={1.5} minWidth={0}>
        <Box component="span" sx={{ display: { lg: 'none', xs: 'inline-flex' } }}>
          <Tooltip arrow title="Menu">
            <IconButton onClick={toggleSidebar} sx={headerIconButtonSx} aria-label="Open menu">
              {!sidebarToggle ? <MenuRoundedIcon fontSize="small" /> : <CloseRoundedIcon fontSize="small" />}
            </IconButton>
          </Tooltip>
        </Box>
        {isCustomer && (
          <ShopBrandMark shopName={shopName} shopLogoUrl={shopLogoUrl} shopInitial={shopInitial} variant="header" />
        )}
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
          <QuickSearch />
        </Box>
      </Stack>

      <Stack direction="row" alignItems="center" spacing={1}>
        <HeaderButtons />
        <Notifications />
        {user?.role === Role.SUPER_ADMIN && (
          <Tooltip title="Billing settings">
            <IconButton sx={headerIconButtonSx} onClick={() => navigate('/billing/settings')} aria-label="Billing settings">
              <SettingsOutlinedIcon sx={{ fontSize: 20 }} />
            </IconButton>
          </Tooltip>
        )}
        <HeaderUserbox />
      </Stack>
    </HeaderWrapper>
  );
}

export default Header;
